export const SUBMIT_MEMBER_SUCCESS = "SUBMIT_MEMBER_SUCCESS"
export const UPDATE_MEMBER_LIST_LOADING = "UPDATE_MEMBER_LIST_LOADING"
export const UPDATE_MEMBER_LIST_PAGINATION = "UPDATE_MEMBER_LIST_PAGINATION"
export const UPDATE_TEMP_LIST_PAGINATION = "UPDATE_TEMP_LIST_PAGINATION"
export const UPDATE_MEMBER_LIST_FILTER = "UPDATE_MEMBER_LIST_FILTER"
export const UPDATE_TEMPLATE_ROUTE = "UPDATE_TEMPLATE_ROUTE"